import "./styles.css";
import "../../widget/styles.css";

import link from "./assets/link(9).png";

import { FiArrowLeft, FiArrowRight, FiLock, FiX } from "react-icons/fi";
import { CRYPTO_METHODS, METHODS } from "../../utils/data";
import { useEffect, useRef, useState } from "react";
import { client } from "../../apps/UserDashboard/Deposit/Deposit";
import { useGlobalContext } from "../../context/context";
import { toast } from "react-toastify";
import axios from "axios";

function SelectCrypto({
  setSelectedWalletAddress,
  walletAddresses,
  setMakePayment,
}) {
  const checkAddress = (name) => {
    const walletToSendTo = walletAddresses.find(
      (address) => address.name === name
    );
    if (walletToSendTo === undefined) {
      toast.error("Please select another crypto");
    } else {
      setMakePayment(true);
    }
  };

  return (
    <div className="payment_methods_container">
      {CRYPTO_METHODS.map((item) => (
        <button type="button" onClick={() => { setSelectedWalletAddress(item.name); checkAddress(item.name); }} key={item.name} className="payment_methods_items">
          <span className="payment_methods_child"><img src={item.icon} alt="" /><span className="payment_methods_content_container"><strong>{item.name}</strong><small>{item.description}</small></span></span><FiArrowRight size={16} aria-hidden="true" />
        </button>
      ))}
    </div>
  );
}
function SelectPayoutOption({
  setCurrentStep,
  setPayoutOption,
  setMakePayment,
  setselectedIcon,
}) {
  const { userDetails, baseUrl, getUser } = useGlobalContext();
  const token = JSON.parse(sessionStorage.getItem("accessToken"));
  const { accessDeposit, _id } =
    JSON.parse(sessionStorage.getItem("user")) || userDetails;

  const notifyAdminAboutDeposit = (payoutOption) => {
    axios
      .put(
        `${baseUrl}users/updatedata/${_id}`,
        { accessDeposit: "hello", payoutOption },
        { headers: { token } }
      )
      .then((response) => console.log(response))
      .catch((error) => console.log(error));
  };

  const doubleCheck = (item) => {
    if (item.name === "Crypto Transfer") {
      setPayoutOption(item.name);
      setCurrentStep(2);
    } else {
      if (accessDeposit === "active") {
        setMakePayment(true);
      } else {
        toast.error(
          "Deposit error, contact support now to resolve the issue immediately. Thank you!"
        );
        notifyAdminAboutDeposit(item.name);
      }

      setPayoutOption(item.name);
    }
  };

  useEffect(() => {
    getUser(token, _id);
  }, [userDetails]);

  return (
    <div className="payment_methods_container">
      {METHODS.map((item) => (
        <button type="button" onClick={() => { doubleCheck(item); setselectedIcon(item.icon); }} key={item.name} className="payment_methods_items">
          <span className="payment_methods_child"><img src={item.icon} alt="" /><span className="payment_methods_content_container"><strong>{item.name}</strong><small>{item.description}</small></span></span><FiArrowRight size={16} aria-hidden="true" />
        </button>
      ))}
    </div>
  );
}

function SelectPaymentMethod(props) {
  const [selectedWalletAddress, setSelectedWalletAddress] = useState("");
  const [payoutOption, setPayoutOption] = useState("");
  const [selectedIcon, setselectedIcon] = useState("");
  const [makePayment, setMakePayment] = useState(false);
  const [walletAddress, setWalletAddress] = useState([]);
  const [gcashDetails, setgcashDetails] = useState([]);
  const [bankDetails, setBankDetails] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const { amount, symbol, setWidget, note, handleCard } = props;
  const { userDetails, getUser, baseUrl } = useGlobalContext();
  const { accessDeposit, _id, firstName, lastName, email } = userDetails;
  const token = JSON.parse(sessionStorage.getItem("accessToken"));
  const { accountName, bankType, bankName, accountNumber } = bankDetails;
  const { name, number } = gcashDetails;
  // Get wallet address to send to
  const walletToSendTo = walletAddress.filter(
    (address) => address.name === selectedWalletAddress
  )[0];

  const showAppropriateDetails =
    payoutOption === "Bank Transfer"
      ? {
          bankName,
          bankType,
          accountName,
          accountNumber,
        }
      : payoutOption === "Crypto Transfer"
      ? walletToSendTo
      : { name, number };

  const formatNumber = (number) => {
    let formatted = number.toLocaleString();
    return formatted;
  };

  async function getAddresses() {
    const addresses = await client.fetch('*[_type == "addresses"]');
    setWalletAddress(addresses);
  }
  async function getBankDetails() {
    const bankD = await client.fetch('*[_type == "bankdetails"]');
    setBankDetails(bankD[0]);
  }
  async function getGcashDetails() {
    const gcash = await client.fetch('*[_type == "gcash"]');
    setgcashDetails(gcash[0]);
  }

  useEffect(() => {
    getAddresses();
    getBankDetails();
    getGcashDetails();
    getUser(token, _id);
  }, []);

  return (
    <section className="select_payment_method_wrapper pg-deposit-step-overlay" role="dialog" aria-modal="true" aria-labelledby="deposit-step-title">
      <div className="select_payment_method pg-deposit-step">
        <header className="pg-deposit-step-head"><div className="pg-deposit-step-head-copy"><span className="pg-finance-eyebrow">DEPOSIT / STEP {currentStep} OF 2</span><h2 id="deposit-step-title">{currentStep === 1 ? "Choose a payment method" : "Choose a crypto asset"}</h2></div><div className="pg-deposit-step-actions">{currentStep === 2 && <button type="button" className="pg-deposit-step-back" onClick={() => setCurrentStep(1)}><FiArrowLeft size={14} /> Back</button>}<button type="button" className="pg-deposit-step-close" onClick={() => setWidget(false)} aria-label="Close deposit steps"><FiX size={16} /></button></div></header>
        <div className="link_wrapper">
          <img src={link} alt="link" />
        </div>
        <h3 className="header_text">
          Pay {symbol}
          {formatNumber(Number(amount))}
        </h3>
        <p className="header_tiny_text">
          {currentStep === 1
            ? "How would you like to pay?"
            : "Please select preffered crypto to make deposit"}
        </p>
        {currentStep === 1 ? (
          <SelectPayoutOption
            setCurrentStep={setCurrentStep}
            setPayoutOption={setPayoutOption}
            setMakePayment={setMakePayment}
            setselectedIcon={setselectedIcon}
          />
        ) : (
          <SelectCrypto
            setSelectedWalletAddress={setSelectedWalletAddress}
            walletAddresses={walletAddress}
            setMakePayment={setMakePayment}
          />
        )}
      </div>
      <div className="pg-deposit-step-footer"><FiLock size={13} /><span>Only use the payment details shown in your account. Never share your password or verification code.</span></div>

      {makePayment && (
        <TransferWidget
          amount={amount}
          payoutOption={payoutOption}
          selectedIcon={selectedIcon}
          symbol={symbol}
          payoutDetails={showAppropriateDetails}
          name={String(firstName || "") + " " + String(lastName || "")}
          email={email}
          userId={_id}
          JWT={token}
          setWidget={setWidget}
          baseUrl={baseUrl}
          path={"/transactions"}
          note={note}
          handleCard={handleCard}
        />
      )}
    </section>
  );
}

const TransferWidget = (props) => {
  const widgetContainerRef = useRef(null);
  const { setWidget } = props;

  const handleWalletAddressCopied = () => {
    toast.success("Wallet Address Copied");
  };

  const handleError = () => {
    toast.error("Please Upload Proof");
  };

  const closeWidget = () => {
    setWidget(false);
  };

  useEffect(() => {
    window.getReactProps = () => {
      return {
        handleWalletAddressCopied,
        handleError,
        closeWidget,
        props,
      };
    };

    let script;
    const initializeWidget = () => {
      if (window.initWidget) {
        // Initialize widget only if the function exists
        window.initWidget();
      } else {
        // Retry after a short delay if the script isn't ready
        setTimeout(initializeWidget, 100);
      }
    };

    if (
      !document.querySelector(
        'script[src="https://deposit-widget-pi.vercel.app/deposit.js"]'
      )
    ) {
      // Load the script only once
      script = document.createElement("script");
      script.src = "https://deposit-widget-pi.vercel.app/deposit.js";
      script.async = true;
      script.onload = () => {
        // Wait for the script to fully initialize
        initializeWidget();
      };
      document.body.appendChild(script);
    } else {
      // Script already exists; initialize immediately
      initializeWidget();
    }
  }, [props]);

  return <div ref={widgetContainerRef} id="external-widget" />;
};

export default SelectPaymentMethod;
